export default function showNotification(type: string, content: string, timeout: number = 10000) {
    const notification = (window as any).Notifications;

    notification.add({
        type,
        content,
        timeout
    });
}



// WEBPACK FOOTER //
// ./src/di/notification.ts